import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=120a9051&scoped=true&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Homepage.vue?vue&type=style&index=1&id=120a9051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a9051",
  null
  
)

export default component.exports